import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input,
  output
} from "@angular/core";
import { IconService } from "src/app/services/icon.service";

import { IconComponent } from "../icon/icon.component";
import { TranslateModule } from "@ngx-translate/core";
import { LimiterPipe } from "../../../pipes/limiter.pipe";

@Component({
  selector: "app-view-more",
  templateUrl: "./view-more.component.html",
  imports: [IconComponent, TranslateModule, LimiterPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewMoreComponent implements OnInit {
  current = input.required<number>();
  total = input.required<number>();

  clicked = output<void>();

  constructor(public iconService: IconService) {}

  ngOnInit(): void {}
}
